import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa'

type LinkType = {
  url: string
  icon: React.FC<{ className?: string }>
}
const links: LinkType[] = [
  {
    url: 'https://www.facebook.com/codehorizon.org',
    icon: FaFacebookF,
  },
  {
    url: 'https://www.instagram.com/codehorizonorg',
    icon: FaInstagram,
  },
  {
    url: 'https://www.linkedin.com/company/codehorizonservices/',
    icon: FaLinkedinIn,
  },
]

const defaultRender = (link: LinkType, key: React.Key) => (
  <li key={key}>
    <a href={link.url} target='_blank'>
      <link.icon />
    </a>
  </li>
)

type Props = {
  className?: string
  render?: (link: LinkType, key: number) => React.ReactNode
}

export const Socials = ({ className, render = defaultRender }: Props) => {
  return (
    <ul className={className}>
      {links.map((link, index) => render(link, index))}
    </ul>
  )
}
